var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paragraph"},[_c('h2',{staticClass:"begin"},[_vm._v(_vm._s(_vm.content.metadata.pres_first))]),_c('br'),_c('h2',[_vm._v(_vm._s(_vm.content.metadata.pres_second))])])}
var staticRenderFns = []

export { render, staticRenderFns }